module.exports = __webpack_public_path__ + "static/media/w_day_cloudy.21a48ed8.svg";